import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

const DUE_STATES = {
  overdue: 'overdue',
  dueToday: 'due-today',
  dueTomorrow: 'due-tomorrow',
  dueSoon: 'due-soon',
  upcoming: 'upcoming',
} as const

export type DueDateState = (typeof DUE_STATES)[keyof typeof DUE_STATES]

export function dueDateState(dueDate: moment.Moment): DueDateState {
  const today = moment().startOf('day')
  const tomorrow = moment().startOf('day').add('1', 'days')
  const fiveDaysFromNow = moment().endOf('day').add('5', 'days')
  const dayDueDate = dueDate.clone().startOf('day')

  if (dayDueDate.isBefore(today)) {
    return DUE_STATES.overdue
  }

  if (dayDueDate.isSame(today, 'day')) {
    return DUE_STATES.dueToday
  }

  if (dayDueDate.isSame(tomorrow, 'day')) {
    return DUE_STATES.dueTomorrow
  }

  if (dayDueDate.isBetween(today, fiveDaysFromNow)) {
    return DUE_STATES.dueSoon
  }

  return DUE_STATES.upcoming
}

const DUE_STATE_LABELS: Record<DueDateState, (days: number) => string> = {
  [DUE_STATES.overdue]: () => i18n.t('dashboard.todo.due_date.overdue'),
  [DUE_STATES.dueToday]: () => i18n.t('dashboard.todo.due_date.today'),
  [DUE_STATES.dueTomorrow]: () => i18n.t('dashboard.todo.due_date.tomorrow'),
  [DUE_STATES.dueSoon]: (days: number) => i18n.t('dashboard.todo.due_date.dueSoon', { n: days }),
  [DUE_STATES.upcoming]: (days: number) => i18n.t('dashboard.todo.due_date.dueSoon', { n: days }),
} as const

export function dueDateStateLabel(state: DueDateState, days: number): string {
  return DUE_STATE_LABELS[state](days)
}

export function dueDateStateData(dueDate?: moment.Moment) {
  const state = dueDate ? dueDateState(dueDate) : null
  const dueDaysBetweenToday = dueDate ? dueDate.diff(moment(), 'days') + 1 : undefined

  return { state, dueDaysBetweenToday }
}
